import React from "react";

const Footer = () => {
  return (
    <div id="footerContainerWrapper">
      <div>
        HP Device Services &#38; Supplies
        Tool&nbsp;&nbsp;&nbsp;|&nbsp;&nbsp;&nbsp;Contact HP DSS Support
      </div>
    </div>
  );
};

export default Footer;
